import * as React from 'react';

import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { ExchangeRefundPassenger } from '../../model';
import { ExchangeRefundSelectControl } from '../ExchangeRefundSelectControl';

interface Props {
	className?: string;
	passengers: ExchangeRefundPassenger[];
	onSelect: (ids: string[], selected: boolean) => void;
}

const ExchangeRefundPassengers: React.FC<Props> = ({ className, passengers, onSelect }) => {
	const { ExchangeRefundPassengers: theme } = useTheme('Entities').Order;

	const onChangeSelect = (ids: string[]) => (selected: boolean) => {
		onSelect(ids, selected);
	};

	return (
		<div className={cn(theme.passengers, className)}>
			{passengers.map(passenger => (
				<ExchangeRefundSelectControl
					key={passenger.ids.join('/')}
					label={passenger.label}
					isSelected={passenger.isSelected}
					isDisabled={passenger.isDisabled}
					onChange={onChangeSelect(passenger.ids)}
				/>
			))}
		</div>
	);
};

export default ExchangeRefundPassengers;
